import React, { SVGProps } from 'react'

export const MultiLikeSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <circle cx={32} cy={32} r={32} fill="#FFC7E6" />
    <path
      fill="#FFC7E6"
      fillRule="evenodd"
      d="M22.958 1.295C9.688 5.197 0 17.467 0 32c0 17.673 14.327 32 32 32 .344 0 .686-.005 1.027-.016l16.396-28.398C48.417 18.173 36.749 5.514 22.958 1.296Z"
      clipRule="evenodd"
    />
    <path
      fill="#FB9BF9"
      fillRule="evenodd"
      d="M40.398 62.887A32.038 32.038 0 0 1 32 64C14.327 64 0 49.673 0 32a31.88 31.88 0 0 1 8.123-21.305c14.875-6.43 34.81 1.06 40.98 19.71l-8.705 32.482Z"
      clipRule="evenodd"
    />
    <path
      fill="#FF8640"
      fillRule="evenodd"
      d="M12.617 57.464c-3.314-4.914-5.375-9.948-6.138-14.912-.766-4.973-.225-9.884 1.667-14.525l-.005-.005c6.617-16.226 30.74-16.367 39.84-.08l-2.95 33.293A31.888 31.888 0 0 1 32 64a31.86 31.86 0 0 1-19.383-6.536Z"
      clipRule="evenodd"
    />
    <path
      fill="#DF4D0E"
      fillRule="evenodd"
      d="M43.824 61.745C55.644 57.042 64 45.497 64 32c0-4.13-.782-8.076-2.206-11.7-4.712-.052-9.861 2.147-13.79 6.55 0 0-.051.051-.13.102a.57.57 0 0 1-.4.13.552.552 0 0 1-.4-.13c-.073-.05-.13-.102-.13-.102-8.408-9.422-22.364-8.791-25.72 2.366-.964 3.193-1.031 6.482-.254 9.738 2.037 8.543 9.899 16.89 22.854 22.79Z"
      clipRule="evenodd"
    />
  </svg>
)
